import { render, staticRenderFns } from "./BulkInventoryForm.vue?vue&type=template&id=731ad49b&scoped=true"
import script from "./BulkInventoryForm.vue?vue&type=script&lang=js"
export * from "./BulkInventoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ad49b",
  null
  
)

export default component.exports